import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../../hooks';
import { useFormHandler } from '../hooks/useFormHandler';
import { useApiHandler } from '../hooks/useApiHandler';
import { ROOT_STATE } from '../../../../store/store.types';
import { IuseDefaultSearchProps } from '../constants/ticketlist.interface';
import { DEFAULT_PAYLOAD } from '../constants/ticketlist.constants';

export const useDefaultSearch = (props: IuseDefaultSearchProps) => {
    const { pageSortInfo } = props;
    const dispatch = useAppDispatch();
    const { filteredListAPI } = useApiHandler();

    const ticketsData = useSelector((state: ROOT_STATE) => state.ticketMgmt.ticketsList.tickets);
    const searchCriteria = ticketsData.searchCriteriaJson || {};

    const { deafultSearchForm } = useFormHandler();
    const { handleSubmit, watch, setValue, reset, register } = deafultSearchForm;

    useEffect(() => {
        const ticketQueue = (searchCriteria.ticketQueues && searchCriteria.ticketQueues[0]) || '';
        const ticketStatus = (searchCriteria.ticketStatus && searchCriteria.ticketStatus[0]) || 'Open';
        const ticketAssignment =
            searchCriteria?.createdByMeFilter ||
            searchCriteria?.myWorkgroupFilter ||
            searchCriteria?.assignedToMeFilter ||
            'assignedToMeFilter';

        setValue('workgroup', ticketQueue);
        setValue('ticketStatus', ticketStatus);
        setValue('ticketAssignment', ticketAssignment);
    }, [!!searchCriteria]);

    const fetchFilteredTickets = useCallback(
        async (formData: any) => {
            const payload = {
                ...DEFAULT_PAYLOAD,
                pageNumber: pageSortInfo.currentPage,
                sortBy: pageSortInfo.sortField,
                sortOrder: pageSortInfo.sortOrder,
                userticketQueues: formData.workgroup || '',
                filterticketStatus: formData.ticketStatus || '',
                userFilter: formData.ticketAssignment || '',
                csrftoken: window.csrf_token,
            };
            await filteredListAPI(dispatch, payload);
        },
        [pageSortInfo],
    );

    return {
        handleSubmit,
        watch,
        setValue,
        reset,
        register,
        fetchFilteredTickets,
    };
};
